<div
  class="flex h-full flex-col gap-5 overflow-hidden rounded transition-transform duration-100 active:scale-105"
  [style.backgroundColor]="cardColor() | contentBuilderColor"
  [style.color]="textColor() | contentBuilderColor"
  (click)="!isProductAvailable() ? null : addToCart()"
  [class.cursor-pointer]="isProductAvailable()"
  [class.pointer-events-none]="!isProductAvailable()"
>
  <div class="relative flex h-full flex-col justify-around gap-5 pb-4">
    <div class="mx-auto flex h-full max-w-44 flex-col justify-between">
      <div>
        <div class="relative mx-auto my-4 aspect-square h-44 w-44 rounded">
          <div
            class="absolute inset-0 h-44 w-44 rounded"
            [appRadialGradient]="product()[ProductKeys.Images]?.thumbnail?.colors"
          ></div>
          @if (product().images?.thumbnail?.url) {
            <img
              class="relative z-10 h-44 w-44 rounded object-cover"
              [src]="product().images?.thumbnail?.url"
              [alt]="product()[ProductKeys.Name]"
            />
          }

          <!-- Discount Badge -->
          <div
            *ngIf="displayDiscount()"
            class="absolute left-3 top-3 z-20 rounded-full bg-red-500 px-3 py-1 text-sm font-bold text-white shadow-lg"
          >
            {{ discountPercentage() }}%
          </div>
        </div>
        <p
          class="line-clamp-2 content-end overflow-hidden px-1 text-center align-bottom font-accent text-xl font-bold"
        >
          {{ product()[ProductKeys.Name] }}
        </p>
      </div>

      <div class="relative flex flex-col flex-wrap">
        <div class="flex w-full justify-center text-center">
          <div
            class="flex flex-row px-2 py-1 text-base font-bold"
            [style.backgroundColor]="cardColor() | contentBuilderColor"
          >
            @if (product()[ProductKeys.PriceToDisplay]) {
              <div class="text-xl font-bold">
                {{ product()[ProductKeys.PriceToDisplay] }}
              </div>
            } @else if (displayDiscount()) {
              <app-price-atom
                size="SM"
                class="mr-1"
                [amount]="product()[ProductKeys.Discount] ?? 0"
                [semiBold]="true"
              ></app-price-atom>
              <app-price-atom
                class="mr-1"
                size="SM"
                [amount]="product()[ProductKeys.Price]"
                [discount]="true"
                [semiBold]="true"
                *ngIf="product()[ProductKeys.Price]"
              ></app-price-atom>
            } @else {
              <app-price-atom
                class="mr-1"
                size="SM"
                [amount]="product()[ProductKeys.Price]"
                [semiBold]="true"
              ></app-price-atom>
            }
            @if (product().description?.length || product().allergens?.length) {
              <i
                (click)="
                  !isProductAvailable() ? null : showProductModal(); $event.stopPropagation()
                "
                class="icon icon-c-info-3 pointer-events-auto absolute right-2 top-0 z-10 content-center pb-3 pl-3 text-center text-2xl font-semibold"
                [style.color]="textColor() | contentBuilderColor"
                [class.opacity-50]="!isProductAvailable()"
              ></i>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- @if (!isProductAvailable()) {
  <div class="absolute flex h-full w-full flex-row flex-wrap items-center justify-center gap-5">
    <div class="z-30">
      @if (!isProductAvailable()) {
        <app-button-atom
          size="S"
          [label]="'_.UNAVAILABLE' | translate"
          thickSize="XS"
          [overrideBgColor]="unavailableButtonBackground()"
          [overrideTextColor]="unavailableButtonText()"
          type="kiosk-primary"
          [full]="true"
        ></app-button-atom>
      }
    </div>
    <div
      class="pointer-events-none absolute h-full w-full opacity-80"
      [class.bg-neutral-400]="!isProductAvailable()"
    ></div>
  </div>
} -->

@if (!isProductAvailable()) {
  <div
    class="absolute top-0 flex h-full w-full flex-row flex-wrap items-center justify-center gap-5"
  >
    <div class="z-30">
      @if (!isProductAvailable()) {
        <app-button-atom
          size="S"
          [label]="'_.UNAVAILABLE' | translate"
          thickSize="XS"
          [overrideBgColor]="unavailableButtonBackground()"
          [overrideTextColor]="unavailableButtonText()"
          type="kiosk-primary"
          [full]="true"
        ></app-button-atom>
      }
    </div>
    <div
      class="unavailable-container pointer-events-none absolute z-20 h-full w-full opacity-80"
      [class.bg-neutral-400]="!isProductAvailable()"
    ></div>
  </div>
}
